import React, {useState} from "react";
import { Button } from "react-bootstrap";

export function SeeAttachment({ attachments }) {
  const [showHoverImage, setShowHoverImage] = useState(false);

  if (attachments?.length === 0) {
    return null;
  } else {
    return (
      <>
        {attachments?.map((file) => {
          return (
            <>
            <div
              // onMouseEnter={() => setShowHoverImage(true)}
              // onMouseLeave={() => setShowHoverImage(false)}
               onClick={() => setShowHoverImage(true)}
               onMouseLeave={() => setShowHoverImage(false)}
            >
              <Button
                size="sm"
                variant="light"
                href={URL.createObjectURL(file.originFileObj)}
           
                target="_blank"
              >
                {file.file_name}
              </Button>
            </div>
            <div className="image-container">
              {file.file_url.toLowerCase().endsWith('.pdf') ? (
                <embed
                  src={file.file_url}
                  type="application/pdf"
                  width="200px"
                  height="200px"
                  className={`pdf-document ${showHoverImage ?  '' : 'hover-image'}`}
                />
              ) : (
                <img
                  src={file.file_url}
                  alt="Your image"
                  className={`image ${showHoverImage ?  '' : 'hover-image'}`}
                />
              )}
            </div>

          </>
          );
        })}
      </>
    );
  }
}
